<!--
 * @Author: zxf
 * @Date: 2022-08-07 21:25:29
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 15:40:43
 * @Description: 检测数据推送
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        {{ dlTypeStr }}
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="120px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="请输入项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="报告编号"
                prop="bgbh"
              >
                <el-input
                  v-model.trim="filterParams.bgbh"
                  class="c-form__input"
                  placeholder="请输入报告编号"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="kTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #bgbh="scope"
            >
              <el-link
                type="primary"
                :disabled="scope.row.previewPdf"
                @click="(e)=>$utils.previewPdf(e,scope.row.bgUrl, scope.row)"
              >
                <i
                  v-show="scope.row.previewPdf"
                  class="el-icon-loading"
                />
                {{ scope.row.bgbh }}
              </el-link>
            </template>
            <!-- <template
              #gzztMc="scope"
            >
              <span
                :class="{
                  'u-text-success' : scope.row.gzztDm==='1',
                  'u-text-danger' : scope.row.gzztDm==='0'
                }"
              >
                {{ scope.row.gzztMc }}
              </span>
            </template> -->

            <template #otherFileId="scope">
              <span
                v-if="scope.row.gdshTsbz === 'Y'"
                class="u-text-success"
              >
                已上传
              </span>
              <k-button
                v-else-if="scope.row.otherFileId === 'Y'"
                btn-text="继续上传"
                :auth-type="true"
                show-text="无"
                type="success"
                plain
                @click="handleDialog('import', scope.row)"
              />
              <k-button
                v-else
                btn-text="上传"
                :auth-type="true"
                type="success"
                show-text="无"
                :disabled="scope.row.gdshTsbz === 'Y'"
                @click="handleDialog('import', scope.row)"
              />
            </template>
            <template
              #gdshTsbz="scope"
            >
              <span
                v-if="scope.row.gdshTsbz === 'Y'"
                class="u-text-success"
                style="cursor: pointer;"
                @click="handleDialog('gdtsReult', { bgId: scope.row.bgId, fd: scope.row});"
              >
                已推送
              </span>
              <span
                v-else-if="scope.row.gdshTsbz === 'U'"
                class="u-text-warning"
              >
                {{ scope.row.bglx === 'ZS' ? '待签章' : (scope.row.bglx === 'YQZ' ? '待盖章' : '-' ) }}
              </span>
              <k-button
                v-else
                btn-text="推送"
                :auth-type="true"
                type="primary"
                @click="handleGdshptSjts(scope.row)"
              />
              <!-- <k-button
          btn-text="导出"
:auth-type="false"
                type="primary"
                @click="handleDialog('gdtsReult', { bgId: scope.row.bgId, fd: scope.row});"
              >
                推送
              </k-button> -->
            </template>
            <el-table-column
              prop="enabled"
              label="联网单位平台（重点单位）"
              width="160"
              align="center"
              fixed="right"
            >
              <template>
                <k-button
                  btn-text="推送"
                  :auth-type="true"
                  type="primary"
                  plain
                  disabled
                  @click="handleAdd()"
                />
              </template>
            </el-table-column>

            <el-table-column
              prop="enabled"
              label="全国系统"
              width="120"
              align="center"
              fixed="right"
            >
              <template>
                <k-button
                  btn-text="推送"
                  :auth-type="true"
                  type="primary"
                  plain
                  disabled
                  @click="handleAdd()"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
      <div class="o-tips">
        报告推送成功后不能修改报告信息
      </div>
    </div>
    <!-- 页面主内容：查询列表 End -->
    <!-- 文件上传 -->
    <jc-import-dialog
      v-if="showDialogName==='import'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />

    <!-- 文件上传 -->
    <gd-result-dialog
      v-if="showDialogName==='gdtsReult'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />
  </div>
</template>

<script>
import { jcsjtsService } from './jcsjts.service';
import JcImportDialog from './importDialog.vue';
import GdResultDialog from './gdBgtsResult.vue';

export default {
  name: 'JcsjtsIndex',
  components: {
    JcImportDialog,
    GdResultDialog
  },
  data () {
    return {
      loading: false, // 页面是否loading状态

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        xmmc: null, // 项目名称
        bgbh: null, // 报告编号
        bgType: 'BGTS',
        bglx: ['DGZ', 'DQZ', 'YQZ', 'YGZ', 'YFB']
      },
      /* 查询条件 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'bgbh', slotName: 'bgbh', label: '报告编号', align: 'left', minWidth: '120', type: 'text' },
        { key: 'xmmc', label: '项目名称', align: 'left', minWidth: '140', type: 'text' },
        { key: 'wtdw', label: '委托单位', align: 'left', minWidth: '100', type: 'text' },
        { key: 'otherFileId', slotName: 'otherFileId', label: '报告上传', align: 'center', width: '120', type: 'text' },
        { key: 'gdshTsbz', slotName: 'gdshTsbz', label: '广东社会平台', align: 'center', width: '120', type: 'text' }
      ],
      /* 表格列配置End */

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */
    };
  },
  computed: {
    /** 动态获取路由名称 */
    dlType () {
      return this.$route.name;
    },
    dlTypeStr () {
      return this.$route.meta.navtabTitle;
    }
  },
  methods: {
    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    },
    /**
     * @description: 广东社会平台数据推送
     * @return {*}
     * @param {*} _id
     */
    handleGdshptSjts (_data) {
      const _xmId = _data.xmId;
      const _bgId = _data.bgId;
      const _this = this;
      const confirmText = [
        '是否确认将数据推送广东社会平台？',
        '注意：',
        '   1、已推送成功的报告不能重复上传报告；',
        '   2、推送的报告以最新上传的报告为准；',
        '   3、上传报告必须是电子报告（电子公章）或原件扫描件（公司印章及签名）；',
        '   4、批准人必须是：注册消防工程师；',
        '   5、报告推送成功后不能修改报告信息。'
      ];
      const newCText = [];
      const h = this.$createElement;
      for (const i in confirmText) {
        newCText.push(h('p', null, confirmText[i]));
      }

      _this.$confirm('确认', {
        title: '确认',
        message: h('div', null, newCText),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        jcsjtsService.gdshptSjts(_xmId, _bgId)
          .then(rsp => {
            this.handleDialog('gdtsReult', { bgId: _bgId, fd: _data, flag: rsp.data.data });
            this.refreshSearch();
          })
          .catch(err => {
            console.error('推送错误！', err);
            this.handleDialog('gdtsReult', { bgId: _bgId });
          })
          .finally(() => {
            _this.loading = false;
          });
      });
    },
    /**
     * @description: 推送到广东平台
     * @return {*}
     */
    handleGdpt (_row) {
      console.log(_row);
      this.loading = true;
      jcsjtsService.gdshptSjts(_row.id)
        .then(rsp => {
          this.$alert('推送成功', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
              _row.gdshpt = '1';
            }
          });
        })
        .catch(err => {
          console.error('推送到广东平台错误！', err);
          _row.gdshpt = '2';
        }).finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 推送到全国系统
     * @return {*}
     */
    handleQgxt (_row) {
      this.loading = true;
      jcsjtsService.qgxtSjts(_row.id)
        .then(rsp => {
          this.$alert('推送成功', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
              _row.qgxt = '1';
            }
          });
        })
        .catch(err => {
          console.error('推送到全国系统错误！', err);
          _row.qgxt = '2';
        }).finally(() => {
          this.loading = false;
        });
    },

    /**
     * @description: 联网单位平台数据推送
     * @return {*}
     * @param {*} _id
     */
    handleLwdwptSjts (_id) {
      const _this = this;
      _this.$confirm('是否确认将数据推送联网单位平台？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        jcsjtsService.qgxtSjts(_id)
          .then(rsp => {
            _this.$alert('推送数据成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
                this.refreshSearch();
              }
            });
          })
          .catch(err => {
            console.error('查询错误！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      });
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      jcsjtsService.getJcbgSjts(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    }
  },
  created () {
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
